<div class="noprint">
<br>
    <h3 class="customer-form-head">Enter Customer Details</h3>

     <div class="form-inline">
        <div>
            <input type="text" class="form-control" placeholder="Enter Customer Name" #customerNameInput>
        </div>
        &nbsp;
        
        <div >
            <input type="text" class="form-control"  placeholder="Enter Customer Place" #customerPlaceInput>
        </div>
        &nbsp;
        
        <div>
            <input type="text" class="form-control"  placeholder="Enter Customer Phone" #customerPhoneInput>
        </div>
        &nbsp;
     <div>
        <button
         class="btn btn-primary btn-block" (click) = "onAddCustometDetails(customerNameInput,customerPlaceInput,customerPhoneInput)">Add User Details</button>
       </div>
     </div>
 </div>   